import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Get locale from cookie
const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

// Detect thank-you status from URL
const getUrlHasThankYou = () => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("thankyou") === "1" || params.get("status") === "submitted";
};

const NewsletterForm = () => {
  const { t } = useTranslation();
  const siteKey = "6Ld7pCErAAAAAN-Aw-ChxsmwXX6DiArl_xJuqLlK";
  const [submitted, setSubmitted] = useState(getUrlHasThankYou());
  const locale = getLocaleFromCookie();

  useEffect(() => {
    // Load Mautic script
    if (!submitted && !window.MauticSDKLoaded) {
      window.MauticSDKLoaded = true;

      const mauticScript = document.createElement("script");
      mauticScript.src = "https://engage.lussana.me/media/js/mautic-form.js?va9981c41";
      mauticScript.crossOrigin = "anonymous";
      mauticScript.onload = () => window.MauticSDK?.onLoad?.();
      document.head.appendChild(mauticScript);

      const recaptchaScript = document.createElement("script");
      recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      recaptchaScript.async = true;
      recaptchaScript.defer = true;
      document.head.appendChild(recaptchaScript);
    }

    // Try to prefill the locale dropdown
    const trySetLocale = () => {
      const localeSelect = document.getElementById("mauticform_input_newsletter_locale");
      if (localeSelect && locale) {
        localeSelect.value = locale;
        // Optional: lock it so user can't change it
        // localeSelect.disabled = true;
      } else {
        setTimeout(trySetLocale, 200);
      }
    };

    trySetLocale();
  }, [submitted, locale]);

  // Add ?thankyou=1 to return field so we can detect success after redirect
  const handleSubmit = () => {
    const returnInput = document.getElementById("mauticform_newsletter_return");
    if (returnInput) {
      returnInput.value = `${window.location.pathname}?thankyou=1`;
    }
  };

  return (
    <>

      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-12">
            {submitted ? (
              <p style={{ lineHeight: '80%' }} className="mt-5">
				<span className="display-5" style={{ fontWeight: 'bold', lineHeight: '50%' }}>{t("newsletter.thankYou")}</ span>
			  </p>
            ) : (
              <form
                autoComplete="off"
                role="form"
                method="post"
                action="https://engage.lussana.me/form/submit?formId=3"
                id="mauticform_newsletter"
                data-mautic-form="newsletter"
                encType="multipart/form-data"
                onSubmit={handleSubmit}
                className="row g-3"
              >
                <div className="col-md-6">
                  <label htmlFor="mauticform_input_newsletter_your_first_name" className="form-label">
                    {t("contacts.firstName")}
                  </label>
                  <input
                    type="text"
                    name="mauticform[your_first_name]"
                    id="mauticform_input_newsletter_your_first_name"
                    className="form-control"
                    placeholder={t("contacts.firstName")}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="mauticform_input_newsletter_your_last_name" className="form-label">
                    {t("contacts.lastName")}
                  </label>
                  <input
                    type="text"
                    name="mauticform[your_last_name]"
                    id="mauticform_input_newsletter_your_last_name"
                    className="form-control"
                    placeholder={t("contacts.lastName")}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <label htmlFor="mauticform_input_newsletter_your_email" className="form-label">
                    {t("contacts.emailAddress")}
                  </label>
                  <input
                    type="email"
                    name="mauticform[your_email]"
                    id="mauticform_input_newsletter_your_email"
                    className="form-control"
                    placeholder={t("contacts.emailAddress")}
                    required
                  />
                </div>

                <input type="hidden" name="mauticform[formId]" value="3" />
                <input type="hidden" name="mauticform[formName]" value="newsletter" />
                <input type="hidden" name="mauticform[return]" id="mauticform_newsletter_return" value="" />

                <input
				  type="hidden"
				  name="mauticform[locale]"
				  id="mauticform_input_newsletter_locale"
				  value={locale}
				/>


                <div className="col-12">
                  <button
                    type="submit"
                    name="mauticform[submit]"
                    value="1"
                    id="mauticform_input_newsletter_submit"
                    className="btn btn-black w-100"
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("contacts.submit")}
                  </button>
                </div>

                <div className="col-12">
                  <p className="text-muted small mt-3">
                    {t("contacts.recaptchaNotice")}{" "}
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                      {t("contacts.privacyPolicy")}
                    </a>{" "}
                    {t("contacts.and")}{" "}
                    <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
                      {t("contacts.termsOfService")}
                    </a>.
                  </p>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsletterForm;
